export default __webpack_public_path__ + "static/usda-logo-reverse@2x-a94c043b61aff5c07a9df28ce2368bc8.png";